var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { RcTooltip } from '../Tooltip';
/**
 * Make a component can be use with `RcTooltip` and Tooltip Props
 */
function withTooltip(Component) {
    return forwardRef(function (props, ref) {
        var title = props.title, useRcTooltip = props.useRcTooltip, TooltipProps = props.TooltipProps, rest = __rest(props, ["title", "useRcTooltip", "TooltipProps"]);
        if (title && useRcTooltip) {
            return (React.createElement(RcTooltip, __assign({ title: title }, TooltipProps),
                React.createElement(Component, __assign({}, rest, { ref: ref }))));
        }
        return React.createElement(Component, __assign({ title: title }, rest, { ref: ref }));
    });
}
export { withTooltip };
